import type { StateCreator } from 'zustand';

export interface FAQSlice {
  currentFAQId?: string;
  childrenCount?: number;
  isInFAQLoop: boolean;
  FAQHistory: string[];
  setFAQHistory: (history: string[]) => void;
  setFAQ: (id: string, childrenCount: number) => void;
  goBack: () => {
    previousId: string | undefined;
    canGoBack: boolean;
    previousChildrenCount?: number;
  };
  setIsInFAQLoop: (val: boolean) => void;
  resetFAQLoop: () => void;
}

export const createFAQSlice: StateCreator<FAQSlice> = set => ({
  isInFAQLoop: true,
  currentFAQId: undefined,
  childrenCount: undefined,
  FAQHistory: [],
  setFAQ: (id: string, childrenCount: number) =>
    set({ currentFAQId: id, childrenCount: childrenCount }),
  goBack: () => {
    let previousId: string | undefined;
    let canGoBack = false;

    set(state => {
      const newHistory = [...state.FAQHistory];
      // Remove current FAQ from history
      newHistory.pop();

      // Get the previous FAQ ID
      previousId = newHistory.at(-1);
      canGoBack = newHistory.length > 0;

      return {
        currentFAQId: previousId,
        FAQHistory: newHistory,
        childrenCount: 1, // This is a placeholder, we do not track children count in history
      };
    });

    return { previousId, canGoBack, previousChildrenCount: 1 };
  },
  setIsInFAQLoop: (val: boolean) => set({ isInFAQLoop: val }),
  setFAQHistory: (history: string[]) => set({ FAQHistory: history }),
  resetFAQLoop: () =>
    set({
      currentFAQId: undefined,
      childrenCount: undefined,
      isInFAQLoop: true,
      FAQHistory: [],
    }),
});
